export default "__VITE_ASSET__AVjoDB7x__"